export function formatCount(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)} 千`;
  }
  return `${value}`;
}

export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${Math.round(value / 10000)} 万`;
  }
  return `${value}`;
}

export function formatDateTime(value: string): string {
  return value;
}